import { Course } from '../types';

export const the_fatherhood_blueprint: Course = {
  id: "the_fatherhood_blueprint",
  title: "The Fatherhood Blueprint",
  description: "A core guide providing foundations and strategies for modern fatherhood and family stability.",
  icon: "🧭",
  totalModules: 12,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/the_fatherhood_blueprint/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/the_fatherhood_blueprint/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/the_fatherhood_blueprint/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/the_fatherhood_blueprint/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/the_fatherhood_blueprint/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/the_fatherhood_blueprint/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/the_fatherhood_blueprint/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/the_fatherhood_blueprint/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/the_fatherhood_blueprint/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/the_fatherhood_blueprint/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/the_fatherhood_blueprint/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    12: { id: 12, title: "Slide 12", slides: [{ title: "Slide 12", content: `<div class="flex justify-center"><img src="/images/courses/the_fatherhood_blueprint/Slide12.PNG" alt="Slide 12" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "Based on 'System Upgrade: Redefining the Mandate', what is the expanded core mandate for 'The Modern Co-Educator'?",
        "o": [
            "Provide & Protect",
            "Provide, Protect & Connect",
            "Only Provide",
            "Only Protect"
        ],
        "a": 1
    },
    {
        "q": "What emotional stance is recommended for 'The Modern Co-Educator' in the 'System Upgrade'?",
        "o": [
            "Suppressed / Action-oriented",
            "Emotionally unavailable",
            "Emotion Words Day-1 / Emotionally available",
            "Avoid emotional expression"
        ],
        "a": 2
    },
    {
        "q": "Which two primary structural columns should a co-educator immediately focus on according to 'The EYFS Framework'?",
        "o": [
            "Cognitive Development and Social Skills",
            "Physical Development and Communication & Language",
            "Emotional Regulation and Creative Expression",
            "Academic Achievement and Fine Motor Skills"
        ],
        "a": 1
    },
    {
        "q": "In 'The Neurobiology of 'Serve and Return'', what is the expected response from Dad (The Return) after the baby initiates (The Serve)?",
        "o": [
            "Wait for a more explicit demand.",
            "Respond immediately with a spoken word, physical touch, or change in expression.",
            "Observe silently without intervention.",
            "Delegate the response to another caregiver."
        ],
        "a": 1
    },
    {
        "q": "During Phase 1 (0-2 Months) of 'Phase-Based Motor Skill Installation', what is the baby's primary focal target?",
        "o": [
            "Toys hanging overhead",
            "The baby's own hands",
            "Dad's face during direct chest-to-chest contact",
            "Reflections in a mirror"
        ],
        "a": 2
    },
    {
        "q": "What is the primary outcome of the 'Dad-Style Play Wave' described in the course material?",
        "o": [
            "Overstimulation leading to distress.",
            "The child learns to avoid challenging situations.",
            "A trust bond is secured, and the child learns the dad is a safe base for exploration.",
            "Development of fine motor skills only."
        ],
        "a": 2
    },
    {
        "q": "According to 'Resilience Scaffolding: The 10-Second Rule', how long should a child be allowed to engage in 'Productive Struggle' before intervention?",
        "o": [
            "Immediately",
            "Until they give up",
            "Exactly 10 seconds",
            "As long as they are visibly frustrated"
        ],
        "a": 2
    },
    {
        "q": "Which step in 'The Circadian Engine (Weather-Agnostic Setup)' aims to neutralize UK weather variables with proper gear?",
        "o": [
            "Outdoor Nature Play",
            "UV Light Absorption",
            "Puddle Suit Protocol",
            "Melatonin Regulation"
        ],
        "a": 2
    },
    {
        "q": "According to 'The Architecture of Language: The Dad Voice', how does 'Paternal Input' approach vocabulary compared to 'Maternal Baseline'?",
        "o": [
            "Rhythmic, simplified",
            "Varied vocabulary, conversational tone",
            "Limited vocabulary, directive tone",
            "Focus only on essential words"
        ],
        "a": 1
    },
    {
        "q": "In 'Blueprint Revision: The Generational Audit', what action is recommended for 'Legacy Behaviors' that fostered security and connection?",
        "o": [
            "Discard them entirely.",
            "Analyze them but do not integrate them.",
            "Integrate them into the new blueprint.",
            "Only keep actions based on the 'Stoic Brit' model."
        ],
        "a": 2
    }
]
};
